import styled from 'styled-components'

export const AccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const AccordionItem = styled.div`
  border: 1px solid var(--vo-cloud);
  border-radius: var(--radius-lg);
  overflow: hidden;
`

export const AccordionHeader = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  background: white;
  border: none;
  cursor: pointer;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: var(--vo-ink);

  &:hover {
    background: var(--vo-mist);
  }
`

export const AccordionSummary = styled.span`
  font-size: 13px;
  color: var(--vo-slate);
  margin-top: 2px;
`

export const AccordionBody = styled.div`
  padding: ${({ $expanded }) => ($expanded ? '12px 16px' : '0 16px')};
  max-height: ${({ $expanded }) => ($expanded ? '2000px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  border-top: ${({ $expanded }) => ($expanded ? `1px solid var(--vo-cloud)` : 'none')};
`

export const Chevron = styled.span`
  transform: ${({ $expanded }) => ($expanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease;
  font-size: 12px;
  color: var(--vo-slate);
`
